import styled from '@emotion/styled';
import { AnnouncementPanel, Typography } from '@innovamat/glimmer-components';
import { usePreferencesQuery } from '@innovamat/glow-api-client';
import { useTranslation } from 'react-i18next';

const StyledAnnouncementPanel = styled(AnnouncementPanel)`
  margin-right: 24px;
  width: auto;
`;

function LeadAnnouncementPanel(): JSX.Element | null {
  const { t } = useTranslation();
  const { data: preferences, isLoading } = usePreferencesQuery();

  const isLeadInTrial = (): boolean => {
    const expirationDate = preferences?.preferences.trialExpirationDate;

    if (!expirationDate) {
      return false;
    }

    return new Date(expirationDate) > new Date();
  };

  if (isLoading || isLeadInTrial()) {
    return null;
  }

  return (
    <StyledAnnouncementPanel
      text={
        <>
          <Typography.Subtitle2>
            {t('lead.disclaimer.title')}
          </Typography.Subtitle2>
          <Typography.Body2>
            {t('lead.disclaimer.description')}
          </Typography.Body2>
        </>
      }
    />
  );
}

export { LeadAnnouncementPanel };
